import i18n from "../../../constants/i18n";
import getKhattabatStore from "../../../stores/khattabat-stores";
import { TVIPKhattabatStatus } from "../../../Types";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";

const ClientSubscriptionStatus = withLiteObserverAndTheme<{
  subscriptionStatus: TVIPKhattabatStatus;
  isInItroductoryPhase: boolean;
}>((props) => {
  const { theme, subscriptionStatus, isInItroductoryPhase } = props;
  const { colors, unitX } = theme;
  const backgroundColor =
    subscriptionStatus === "EXPIRED"
      ? colors.all.lightRed
      : isInItroductoryPhase
        ? colors.all.yellow
        : subscriptionStatus === "ACTIVE"
          ? colors.all.lightGreen
          : colors.all.orange;

  const borderColor =
    subscriptionStatus === "EXPIRED"
      ? colors.all.red
      : isInItroductoryPhase
        ? colors.all.yellow
        : subscriptionStatus === "ACTIVE"
          ? colors.all.seaGreen
          : colors.all.darkOrange;

  const isPaidClient =
    getKhattabatStore().conversationsClientType.get() === "PAID";

  return isPaidClient ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={90}
      height={55}
      color={backgroundColor}
      style={{
        border: `${3 * unitX}px solid ${borderColor}`,
        borderRadius: 20 * unitX
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={25}
        text={
          subscriptionStatus === "EXPIRED"
            ? `${i18n.get("SUBSCRIPTION_EXPIRED")}`
            : isInItroductoryPhase
              ? `${i18n.get("TRIAL")}`
              : `${i18n.get("SUBSCRIPTION_ACTIVE")}`
        }
        isSpan={false}
        color={colors.all.black}
        style={{}}
      />
    </ET3Div>
  ) : null;
});
export default ClientSubscriptionStatus;
